import { render, staticRenderFns } from "./gruposPerfilesIndex.vue?vue&type=template&id=5a308312&scoped=true"
import script from "./gruposPerfilesIndex.vue?vue&type=script&lang=js"
export * from "./gruposPerfilesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a308312",
  null
  
)

export default component.exports